import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { View, Text, AppState, Image, ImageBackground, TouchableOpacity, Dimensions } from 'react-native';
import { DeviceInfo, CookieManager, QLinearGradient } from 'qunar-react-native';
import getStyle from './style';
import SizeUtil from '../../Utils/SizeUtil';
// import rootStore from '../../Store/index';
import { qav } from '../../Utils/qav';
import RootStore from '../../Store';


@inject((rootStore: RootStore) => ({
    rootStore,
    deviceWidth: rootStore.size.deviceWidth,
}))
@observer
export default class GuideWeChat extends Component<any> {
    private topBannerData: any;
    public componentDidMount() {
        AppState.addEventListener('change', this._handleAppStateChange);
    }

    public componentWillUnmount() {
        AppState.removeEventListener('change', this._handleAppStateChange);
    }
    
    public render() {
        const { topBannerType, topBannerData } = this.props.rootStore.guideWeChat;
        let styles = getStyle();
        // console.log(topBannerType,topBannerData)
        const keys = Object.keys(topBannerData);
        if(!keys.length){
            return <View></View>;
        };
        if(topBannerType === 'qmember'){
            const {rankLevelNum, memberLevelName, noticeText, memberLevelIcon, rankLevelIcon, preReward, rearReward } = topBannerData || {};
            const textArr = noticeText && noticeText.match(/([\s\S]*){{([\s\S]*)}}([\s\S]*)/);
            // let preRankLevelNum = preReward?.rankLevelNum || 0;
            let rearRankLevelNum = rearReward?.rankLevelNum || rankLevelNum;
            // console.log(preRankLevelNum,rearRankLevelNum)
            this._qavQmember('show',topBannerType,'bannerShow','openshow');
            return(
                <TouchableOpacity
                    // style={styles.benefitContainer}
                    // activeOpacity={0.8}
                    onPress={this.qmemberClick}
                >
                    <QLinearGradient
                        colors={['#FFF3D1', '#FFFFFF']}
                        style={styles.vipContainer}
                        start={{x: 1.0, y: 0}}
                        end={{x: 0, y: 0}}
                    >
                        <View style={styles.vipLeft}>
                            <View style={styles.leftCon}>
                                <Image source={{uri: memberLevelIcon}} style={styles.vipIcon} />
                                <Text style={styles.vipText}>{memberLevelName}</Text>
                                <View style={styles.levelBox}>
                                    <Image source={{uri: rankLevelIcon}} style={styles.levelIcon} />
                                    <View style={styles.vipNumCon}>
                                        <Text style={styles.vipNum}>{rankLevelNum}</Text>
                                    </View>
                                </View>
                            </View>
                            {
                                textArr?(
                                    <View style={{flexDirection: 'row'}}>
                                        <Text style={styles.leftText}>{textArr[1]}</Text>
                                        <Text style={[styles.leftText,{color:'#FF8401',fontFamily:'20th_bold' }]}>{textArr[2]}</Text>
                                        <Text style={styles.leftText}>{textArr[3]}</Text>
                                    </View>
                                ):(
                                    <Text style={styles.leftText}>{noticeText}</Text>
                                )
                            }
                        </View>
                        <View style={styles.vipRight}>
                            <View style={styles.levelGrow}>
                                <View style={[styles.levelLine,{right:SizeUtil.getSize(35)}]}>
                                    {
                                        (rankLevelNum > 1) && (
                                            <QLinearGradient
                                                colors={['#FFFFFF', '#FFBB73']}
                                                style={styles.lline}
                                                start={{x: 0, y: 0}}
                                                end={{x: 1.0, y: 0}}
                                            >   
                                            </QLinearGradient>
                                        )
                                    }
                                    {
                                        (rankLevelNum < (rearRankLevelNum-1)) && (
                                            <View style={styles.mline}>
                                                <View style={styles.mline0}></View>
                                                <View style={styles.mlinel}></View>
                                                <View style={styles.mlinem}></View>
                                                <View style={styles.mlinem}></View>
                                                <View style={styles.mlinem}></View>
                                                <View style={styles.mliner}></View>
                                            </View>
                                        )
                                    }
                                    {
                                        (rankLevelNum == (rearRankLevelNum-1)) && (
                                            <View style={styles.mline}>
                                                <View style={styles.mline0}></View>
                                                <View style={styles.mline1}></View>
                                            </View>
                                        )
                                    }
                                    {
                                        (rankLevelNum == rearRankLevelNum) && (
                                            <View style={styles.mline}>
                                                <View style={styles.mline0}></View>
                                                <View style={styles.mline2}></View>
                                            </View>
                                        )
                                    }
                                </View>
                                <View style={[styles.lvBox,{marginRight:SizeUtil.getSize(36)}]}>
                                    <Text style={styles.lvText}>{preReward?.rankLevel}</Text>
                                </View>
                                <View style={[styles.lvBox,{marginRight:SizeUtil.getSize(25)}]}>
                                    <Text style={styles.lvText}>{rearReward?.rankLevel}</Text>
                                </View>
                            </View>
                            <View style={styles.levelRights}>
                                <QLinearGradient
                                    colors={['#FFF4DD', '#E6DABE']}
                                    style={[styles.levelImgBg,{marginRight:SizeUtil.getSize(46)}]}
                                    start={{x: 0, y: 0}}
                                    end={{x: 0, y: 1.0}}
                                >
                                    <Image source={{uri: preReward?.img}} style={styles.levelImg} />
                                </QLinearGradient>
                                <QLinearGradient
                                    colors={['#FFF4DD', '#E6DABE']}
                                    style={[styles.levelImgBg,{marginRight:SizeUtil.getSize(30)}]}
                                    start={{x: 0, y: 0}}
                                    end={{x: 0, y: 1.0}}
                                >
                                    <Image source={{uri: rearReward?.img}} style={styles.levelImg} />
                                </QLinearGradient>
                            </View>
                        </View>
                    </QLinearGradient>
                </TouchableOpacity>
            )
        }

        // 机酒权益入口
        if (topBannerType === 'jijiuBanner') {
            const { displayHotelFlowOrderBanner, hotelFlowOrderBannerImageUrl } = topBannerData || {};
            if(!displayHotelFlowOrderBanner){
                return <View></View>;
            };
            const qavJson = {
                bizType: 'pp',
                module: 'jijiurukou_gonggongdingdan',
                appcode: 'hybridid',
                page: 'flightHotel',
                id: 1,
                operType: 'show',
                key: 'pp/flightHotel/jijiurukou_gonggongdingdan/show/1',
                operTime: new Date().getTime().toString()
            }
            qav(qavJson);

            // const win = Dimensions.get('window');
            // 24为左右间距
            const activityWidth = this.props.rootStore.size.deviceWidth - 24;
            // 71 352为图片原宽高
            const activityHeight = activityWidth * (71 / 352);

            return (
                <TouchableOpacity
                    style={styles.activityContainer}
                    activeOpacity={0.8}
                    onPress={this.hotelFlowOrderPress}
                >
                    <Image
                        source={{ uri: hotelFlowOrderBannerImageUrl }}
                        style={{
                            width: activityWidth,
                            height: activityHeight
                        }}
                    />
                </TouchableOpacity>
            )

            // return (
            //     <TouchableOpacity
            //         activeOpacity={0.8}
            //         onPress={this.hotelFlowOrderPress}
            //     >
            //         <ImageBackground
            //             source={{ uri: 'https://picbed.qunarzz.com/b7ecda0debd8fcd8454811f5c24f00c4.png' }}
            //             style={{
            //                 width: activityWidth,
            //                 height: activityHeight
            //             }}
            //             resizeMode='stretch'
            //         >
            //             <View style={[styles.flightContainer, {
            //                 width: activityWidth,
            //                 height: activityHeight,
            //                 justifyContent: 'space-around'
            //             }]}>
            //                 <Text style={styles.flightContainerDesc}>
            //                     60<Text style={styles.flightContainerPrice}>元</Text>
            //                 </Text>
            //                 <View style={{
            //                         flexDirection: 'column',
            //                     }}>
            //                         <Text>机票用户专属酒店券</Text>
            //                         <Text>机票用户专属酒店券</Text>
            //                     </View>
            //                     <View>
            //                     <Image source={{ uri: 'https://picbed.qunarzz.com/b7ecda0debd8fcd8454811f5c24f00c4.png' }} style={styles.tipIcon} />
            //                     </View>
            //                 {/* <Button
            //                     text={'立即出行'}
            //                     size={'small'}
            //                     needGradient
            //                     gradientColors={['blue', 'red']}
            //                     customStyle={{
            //                         width: SizeUtil.getSize(68)
            //                     }}
            //                 /> */}
            //                 {/* <View style={styles.bindBtn}>
            //                     <Text style={styles.bindBtnTitle}>立即领券</Text>
            //                 </View> */}
            //             </View>
            //         </ImageBackground>
            //     </TouchableOpacity>
            // )
        }

        // 微信关注入口
        if (topBannerType === 'wechat') {
            const qavJson = {
                bizType: 'pp',
                module: 'pushopen',
                page: 'orderList',
                title: '去开启',
                operType: 'show',
                operTime: new Date().getTime().toString()
            };
            qav(qavJson);

            const {
                wechatBindButton,
                wechatBindIcon,
                wechatBindSubTitle,
                wechatBindTitle,
                wechatbindBackGround,
            } = topBannerData || {};

            return (
                <TouchableOpacity
                    // style={styles.benefitContainer}
                    activeOpacity={0.8}
                    onPress={this.bindClick}
                >
                    <QLinearGradient
                        colors={['#E6F8F1', '#FFFFFF']}
                        style={styles.container}>
                        <ImageBackground
                            source={{uri: wechatbindBackGround}}
                            style={styles.backgroundImage}
                            resizeMode='contain'
                        >
                        </ImageBackground>
                        <View style={styles.tip} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.WECHAT_BIND)}>
                                <Image source={{uri: wechatBindIcon}} style={[styles.tipIcon]} />
                                <Text style={styles.tipText}>开启公众号通知，重要消息不错过</Text>
                            </View>
                            <View style={styles.contentContainer}>
                                <View>
                                    <Text style={styles.title}>{wechatBindTitle}</Text>
                                    <Text style={styles.subTitle}>{wechatBindSubTitle}</Text>
                                </View>
                                <View style={styles.bindBtn}>
                                    <Text style={styles.bindBtnTitle}>{wechatBindButton}</Text>
                                </View>
                            </View>
                    </QLinearGradient>
                </TouchableOpacity>
            );
        }
        if (topBannerType === 'newWechat'){
            const { imageUrl, imageWidth, imageHeight} = topBannerData || {};
            if(!imageUrl){
                return <View></View>;
            };
            const qavJson = {
                ext:{
                    bannerType:topBannerType
                },
                bizType: 'pp',
                module: 'default',
                appcode: 'cmn_component_order',
                page: 'orderListBanner',
                id: 'OrderListBanner',
                operType: 'show',
                key: 'pp/orderListBanner/default/show/OrderListBanner',
                operTime: new Date().getTime().toString()
            }
            qav(qavJson);
            return (
                <TouchableOpacity
                    style={styles.newChatContainer}
                    activeOpacity={0.8}
                    onPress={this.bindNewChat}
                >
                    <Image
                        source={{ uri: imageUrl }}
                        style={{  width: SizeUtil.getSize(imageWidth||375), height: SizeUtil.getSize(imageHeight||68) }}
                    />
                </TouchableOpacity>
            )
        }
        return <View style={{ width: '100%', height: 1, backgroundColor: '#EEEEEE' }} />;
    }

    _qavQmember = (operType:string,type:string,id:string,title:string) => {
        const qavJson = {
            ext:{
                showType:type
            },
            bizType: 'pp',
            module: 'pushopen',
            appcode:'cmn_component_order',
            page: 'orderList',
            id,
            title,
            operType,
            key:`pp/orderList/pushopen/${operType}/${id}`,
            operTime: new Date().getTime().toString()
        };
        qav(qavJson);
    }

    qmemberClick = () => {
        const { topBannerType, topBannerData } = this.props.rootStore.guideWeChat;
        const { button } = topBannerData || {};
        const {jumpUrl} = button || {};
        this._qavQmember('click',topBannerType,'bannerClick','openclick');
        Ext.Router.Bridge.sendScheme({
            url: `${DeviceInfo.scheme}${jumpUrl}`
        }, () => null);
    }

    private hotelFlowOrderPress = () => {
        const qavJson = {
            bizType: 'pp',
            module: 'jijiurukou_gonggongdingdan',
            appcode: 'hybridid',
            page: 'flightHotel',
            id: '2',
            operType: 'click',
            key: 'pp/flightHotel/jijiurukou_gonggongdingdan/click/2',
            operTime: new Date().getTime().toString()
        }
        qav(qavJson);
        const { hotelFlowOrderBannerJumpUrl } = this.props.rootStore.guideWeChat.topBannerData;
        Ext.Router.Bridge.sendScheme({
            url: hotelFlowOrderBannerJumpUrl ? hotelFlowOrderBannerJumpUrl : `${DeviceInfo.scheme}://hy?url=https%3A%2F%2Fm.flight.qunar.com%2Fshark%2Factive%3Fcid%3D2910%26source%3Dgonggongdingdanliebiao%26fromForLog%3D873&type=navibar-none`
        }, () => null);
    };
    private _handleAppStateChange = (nextAppState: string) => {
        let guideWeChat = this.props.rootStore.guideWeChat || {};
        // console.log('nextAppState',nextAppState)
        if (nextAppState === 'active') {/// && guideWeChat?.topBannerData?.showGuideWeChat === true
            // 如果是true ，表示从后台进入了前台 ，请求数据，刷新页面。或者做其他的逻辑
            guideWeChat.toggleShowGuideChat('all');
        }
    };

    private bindClick = () => {
        const qavJson = {
            bizType: 'pp',
            module: 'pushopen',
            page: 'orderList',
            title: '去开启',
            operType: 'click',
            operTime: new Date().getTime().toString()
        };
        qav(qavJson);

        const { 
            isBind,
            subscribe,
            wechatBindImage,
        } = this.props.rootStore.guideWeChat.topBannerData;

        const host = DeviceInfo.isIOS ? 'pcenter' : 'share';
        const userName = 'gh_7ffb9c5d761f';
        let miniprogramType = DeviceInfo.isIOS ? '0' : 'release';
        // if (DeviceInfo.releaseType === 'beta') {
        //     miniprogramType = DeviceInfo.isIOS? '1': 'test'
        // }

        // 未绑定跳转到小程序绑定页
        if (!isBind) {

            let juery = '?scene=ppxc&source=pporder';
            juery += `&hasBind=${Number(isBind)}`;
            juery += `&hasFocus=${Number(subscribe)}`;
            juery += `&contentImg=${encodeURIComponent(encodeURIComponent(wechatBindImage))}`;

            this._getCookie('_q')
                .then((cookieValue: any) => {
                    juery += `&_q=${escape(cookieValue)}`;
                    return this._getCookie('_v');
                })
                .then((cookieValue: any) => {
                    juery += `&_v=${escape(cookieValue)}`;
                    return this._getCookie('_t');
                })
                .then((cookieValue: any) => {
                    juery += `&_t=${escape(cookieValue)}`;

                    // 跳转到微信小程序
                    const path = escape('/pages/ppTrip/focusWechat/index' + juery);
                    const url = `${DeviceInfo.scheme}://${host}/launchMiniProgram?userName=${userName}&path=${path}&miniprogramType=${miniprogramType}`;

                    Ext.Router.Bridge.sendScheme({ url }, () => null);
                })
                .catch((error) => {});
        } else {
            // 绑定了跳转关注引导页
            const weixinUrl = `https://mp.weixin.qq.com/s/mKCd1rE5e6aI_68M0Kfm_g?source=pporder`;
            const path = escape('/pages/platform/actWebWx/index?url=' + encodeURIComponent(encodeURIComponent(weixinUrl)));
            Ext.Router.Bridge.sendScheme({
                url: `${DeviceInfo.scheme}://${host}/launchMiniProgram?userName=${userName}&path=${path}&miniprogramType=${miniprogramType}`
            }, () => null);
        }
    };
    private bindNewChat = () => {
        const { topBannerData,topBannerType } = this.props.rootStore.guideWeChat;
        const { jumpSchema } = topBannerData || {};
        const qavJson = {
            ext:{
                bannerType:topBannerType
            },
            bizType: 'pp',
            module: 'default',
            appcode: 'cmn_component_order',
            page: 'orderListBanner',
            id: 'OrderListBanner',
            operType: 'click',
            key: 'pp/orderListBanner/default/click/OrderListBanner',
            operTime: new Date().getTime().toString()
        };
        qav(qavJson);
        
        Ext.Router.Bridge.sendScheme({
            url: `${DeviceInfo.scheme}${jumpSchema}`
        }, () => null);
    }
    private _getCookie(key: string) {
        return new Promise((resolve, reject) => {
            CookieManager.getCookieForKey(
                key,
                'https://www.qunar.com',
                (cookie) => {
                    resolve(cookie.value);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }
}
